import PropTypes from 'prop-types';
import React from 'react';
import { Select, MenuItem, useMediaQuery } from '@mui/material';
import dayjs from 'dayjs';

const CustomDropdown = ({ value, onChange, startDate, endDate }) => {
	const isMobile = useMediaQuery('(max-width: 600px)');

	return (
		<Select
			value={value}
			onChange={onChange}
			sx={{
				borderTopRightRadius: isMobile ? '0' : '8px',
				borderRadius: isMobile ? '8px' : null,
				height: '100%',
				'& .MuiSelect-select': {
					padding: '0 20px'
				},
				'&:hover': {
					'&& fieldset': { border: isMobile ? '2px sloid #B7D423' : 'none' }
				},
				'&.Mui-focused': {
					'&& fieldset': { border: isMobile ? '2px sloid #B7D423' : 'none' }
				},
				'& fieldset': { border: isMobile ? '2px sloid #B7D423' : 'none' },
				'&:before': { border: isMobile ? '2px sloid #B7D423' : 'none' }
			}}
		>
			<MenuItem value={1}>1 Day</MenuItem>
			<MenuItem value={7}>7 Days</MenuItem>
			<MenuItem value={15}>15 Days</MenuItem>
			<MenuItem value={30}>1 Month</MenuItem>
			<MenuItem value={90}>3 Months</MenuItem>
			<MenuItem
				value={100}
				onClick={() => onChange({ target: { value: 100 } })}
			>
				{startDate === null || endDate === null ? (
					'Custom Date'
				) : (
					<>
						{dayjs(startDate).format('DD MMM YYYY')} to <br />
						{dayjs(endDate).format('DD MMM YYYY')}
					</>
				)}
			</MenuItem>
		</Select>
	);
};

export default CustomDropdown;

CustomDropdown.propTypes = {
	value: PropTypes.any,
	onChange: PropTypes.any,
	startDate: PropTypes.any,
	endDate: PropTypes.any
};
